import {
    NOT_APPLICABLE_TEXT,
    QUOTA_TYPE_CANDIDATE_QUOTA_ID,
    QUOTA_TYPE_EMPTY_TEXT,
    QUOTA_TYPE_RESERVED_SEATS_ID
} from '../constants';
import {
    CountryProfile,
    CountryProfileFilters,
    CountryProfileResult
} from '../types';
import {
    getDateObj,
    getFullYearFromDatetime
} from './date.utils';

export const getCandidateQuotaDetails = (countryProfile: CountryProfile): string => (
    countryProfile.typeOfQuotaIds.indexOf(QUOTA_TYPE_CANDIDATE_QUOTA_ID) !== -1
    ? countryProfile.rankingPlacementDetails || QUOTA_TYPE_EMPTY_TEXT
    : NOT_APPLICABLE_TEXT
);

export const getReservedSeatsDetails = (countryProfile: CountryProfile): string => (
    countryProfile.typeOfQuotaIds.indexOf(QUOTA_TYPE_RESERVED_SEATS_ID) !== -1
    ? countryProfile.methodOfFillingSeats || QUOTA_TYPE_EMPTY_TEXT
    : NOT_APPLICABLE_TEXT
);

export const filterLatestCountryProfiles = (
    countryProfileList: CountryProfile[],
): CountryProfile[] => {
    const resultDict: { [countryIdKey: string]: CountryProfile } = {};

    countryProfileList.forEach(countryProfile => {
        const countryIdKey = String(countryProfile.countryId);

        if (!resultDict[countryIdKey]) {
            resultDict[countryIdKey] = countryProfile;
        }
        else if (resultDict[countryIdKey].datetime < countryProfile.datetime) {
            resultDict[countryIdKey] = countryProfile;
        }
    });

    return Object.values(resultDict);
};

export const filterMostRecentCountryProfiles = (
    countryProfileList: CountryProfile[],
    mostRecentDateFromTaxonomies: string | null
): CountryProfile[] => {
    if (mostRecentDateFromTaxonomies) {
        const mostRecentDateObjectFromTaxonomies = getDateObj(mostRecentDateFromTaxonomies);
        const resultDict: {
            [countryIdKey: string]: CountryProfile
        } = {};

        countryProfileList.forEach(countryProfile => {
            const countryIdKey = String(countryProfile.countryId);

            if (!countryProfile.date.trim()) {
                resultDict[countryIdKey] = countryProfile;
                return;
            }

            const currentDateObject = getDateObj(countryProfile.date);
    
            if (currentDateObject >= mostRecentDateObjectFromTaxonomies) {
                if (resultDict[countryIdKey]) {
                    if (currentDateObject > getDateObj(resultDict[countryIdKey].date)) {
                        resultDict[countryIdKey] = countryProfile;
                    }
                }
                else {
                    resultDict[countryIdKey] = countryProfile;
                }
            }
        });

        return Object.keys(resultDict).map(countryId => resultDict[countryId]);
    }

    return [];
};

export const filterCountryResult = (
    filterCallback: (countryProfile: CountryProfile) => boolean
) => (
    (countryResult: CountryProfileResult): boolean => {
        if (countryResult.countryProfile) {
            return filterCallback(countryResult.countryProfile);
        }

        return true;
    }
);

export const getNotFoundCountryIdsFromCountryProfiles = (
    countryIds: number[],
    countryProfiles: CountryProfile[]
) => countryIds.filter(countryId => (
    countryProfiles.every(countryProfile => (
        countryProfile.countryId !== countryId
    ))
));

export const toCountryProfileList = (
    resultList: CountryProfileResult[]
): CountryProfile[] => resultList
    .map(result => result.countryProfile!)
    .filter(profile => !!profile);

export const checkSpecialConditionToHideTable = (
    filters: CountryProfileFilters,
    resultListLength: number = 0,
): boolean => (
    !resultListLength
    && !filters.countryIds.length
    && filters.localLevel
    && (filters.datetime ? getFullYearFromDatetime(filters.datetime) : null) === 2022
);
